import formInputsTypes from '../simulatorConstant';
import AxeManuel from 'assets/img/axe-manuel.png';
import AxeMotorise from 'assets/img/axe-motorise.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import MoteurStoreBanne from 'assets/img/moteur-store-banne.png';
import StoreBanne from 'assets/img/store-banne.png';
import ToileStoreBanne from 'assets/img/toile-store-banne.png';

const Options = {
	id: 'OptionsVR',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: "Autre main d'oeuvre",
	name: 'Options',
	className: 'col-12 mt-6',
	classGroup: 'simulator-check',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'Création store banne complet',
			value: 'Création store banne complet',
			label: 'Création store banne complet',
			isInline: true,
			lst_price: 0,
			product_id: 9495,
			description: '- Création complète d’un store banne.',
		},
		{
			id: 'Tirage de ligne électrique',
			label: 'Tirage de ligne électrique',
			value: 'Tirage de ligne électrique',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Tirage de la ligne électrique pour alimentation du moteur.',
		},
		{
			id: 'Mise en place des agrafes',
			label: 'Mise en place des agrafes',
			value: 'Mise en place des agrafes',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise en place des fixations de la toile du store banne.',
		},
		{
			id: 'Branchement électrique',
			label: 'Branchement électrique',
			value: 'Branchement électrique',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Branchement électrique du moteur du store banne.',
		},
		{
			id: 'Réglage fin de course',
			label: 'Réglage fin de course',
			value: 'Réglage fin de course',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Réglage des fins de course du store banne.',
		},
		{
			id: 'Mise en service',
			label: 'Mise en service',
			value: 'Mise en service',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise en service et test du store banne.',
		},
		{
			id: 'Mise à la décharge',
			label: 'Mise à la décharge',
			value: 'Mise à la décharge',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Mise à la décharge des éléments déposés.',
		},
		{
			id: 'Fermeture du coffre',
			label: 'Fermeture du coffre',
			value: 'Fermeture du coffre',
			lst_price: 0,
			isInline: true,
			product_id: 9495,
			description: '- Fermeture et remise en place du coffre du store banne.',
		},
	],
};

const voletComplet = {
	id: 'VOLET_COMPLET',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Store banne complet',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: Options,
	nextStepData: Options,
	options: [
		{
			id: 'depose_volet_complet',
			label: 'Dépose store banne complet',
			value: 'depose_volet_complet',
			description: '- Dépose complète du store banne existant avec sécurisation.',
			lst_price: 80,
			imageUrl: StoreBanne,
			isInline: true,
		},
		{
			id: 'pose_volet_complet',
			label: 'Pose store banne complet',
			value: 'pose_volet_complet',
			description: '- Pose complète d’un store banne avec réglages et essais.',
			lst_price: 120,
			imageUrl: StoreBanne,
			isInline: true,
		},
	],
};

const tablier = {
	id: 'TABLIER',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Toile de store banne',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: voletComplet,
	nextStep: voletComplet,
	options: [
		{
			id: 'depose_tablier',
			label: 'Dépose toile',
			value: 'depose_tablier',
			description: '- Dépose de la toile du store banne avec précaution.',
			lst_price: 42,
			imageUrl: ToileStoreBanne,
			isInline: true,
		},
		{
			id: 'pose_tablier',
			label: 'Pose toile',
			value: 'pose_tablier',
			description: '- Pose de la toile du store banne.',
			lst_price: 42,
			imageUrl: ToileStoreBanne,
			isInline: true,
		},
	],
};

const axeMotorise = {
	id: 'AXE_MOTORISE',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe motorisé',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: tablier,
	nextStep: tablier,
	options: [
		{
			id: 'depose_axe_motorise',
			label: 'Dépose axe motorisé',
			value: 'depose_axe_motorise',
			description: '- Dépose de l’axe motorisé du store banne.',
			lst_price: 60,
			imageUrl: AxeMotorise,
			isInline: true,
		},
		{
			id: 'pose_axe_motorise',
			label: 'Pose axe motorisé',
			value: 'pose_axe_motorise',
			description: '- Pose d’un axe motorisé pour store banne.',
			lst_price: 68,
			imageUrl: AxeMotorise,
			isInline: true,
		},
	],
};

const axeManuel = {
	id: 'AXE_MANUEL',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe manuel',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeMotorise,
	nextStep: axeMotorise,
	options: [
		{
			id: 'depose_axe_manuel',
			label: 'Dépose axe manuel',
			value: 'depose_axe_manuel',
			description: '- Dépose de l’axe manuel du store banne.',
			lst_price: 30,
			imageUrl: AxeManuel,
			isInline: true,
		},
		{
			id: 'pose_axe_manuel',
			label: 'Pose axe manuel',
			value: 'pose_axe_manuel',
			description: '- Pose d’un axe manuel pour store banne.',
			lst_price: 48,
			imageUrl: AxeManuel,
			isInline: true,
		},
	],
};

const moteur = {
	id: 'MOTEUR',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Moteur',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeManuel,
	nextStep: axeManuel,
	options: [
		{
			id: 'depose_moteur',
			label: 'Dépose moteur',
			value: 'depose_moteur',
			description: '- Dépose du moteur du store banne.',
			lst_price: 40,
			imageUrl: MoteurStoreBanne,
			isInline: true,
		},
		{
			id: 'pose_moteur',
			label: 'Pose moteur',
			value: 'pose_moteur',
			description: '- Pose d’un moteur pour store banne.',
			lst_price: 48,
			imageUrl: MoteurStoreBanne,
			isInline: true,
		},
	],
};

const MainOuvreDataStore = {
	id: 'MO',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Manivelle',
	name: 'Manivelle',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStepData: moteur,
	nextStep: moteur,
	options: [
		{
			id: 'depose_manivelle',
			value: 'depose_manivelle',
			label: 'Dépose manivelle',
			description: '- Dépose de la manivelle du store banne.',
			lst_price: 25,
			imageUrl: ManoeuvreManuel,
			isInline: true,
		},
		{
			id: 'pose_manivelle',
			label: 'Pose manivelle',
			value: 'pose_manivelle',
			description: '- Pose d’une manivelle pour store banne.',
			lst_price: 48,
			imageUrl: ManoeuvreManuel,
			isInline: true,
		},
	],
};

export default MainOuvreDataStore;
